import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';

const ModalSuggestArchiving = ({ open, onClose, justification, file }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Sugestão de Arquivamento Interno</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom style={{ marginTop: 16, marginBottom: 6 }}>
          <strong>Justificativa:</strong>
        </Typography>
        <Typography variant="body2" style={{ whiteSpace: 'pre-wrap', marginBottom: 20 }}>
          {justification}
        </Typography>
        {file && (
          <>
            <Typography variant="body1" gutterBottom>
              <strong>Arquivo:</strong>
            </Typography>
            <Box
              component="a"
              href={file.url}
              download={file.name}
              display="flex"
              alignItems="center"
              p={1}
              style={{
                border: '1px solid #ccc',
                borderRadius: 4,
                cursor: 'pointer',
                textDecoration: 'none',
                color: 'inherit',
              }}
            >
              <AttachFileIcon fontSize="small" />
              <Typography variant="body2" style={{ marginLeft: 4 }}>
                {file.name}
              </Typography>
            </Box>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" style={{ marginTop: 20 }}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalSuggestArchiving;
